export default __webpack_public_path__ + "static/miles-e7134f05ee9b08e1e58c4cc22fa286b9.png";